export default function ActivityPage() {
  return (
    <main className="tab-main untab">
      <section className="wip-section">
        <h1>Oops, I'm an Activity Tab in progress. Try other tabs?</h1>
      </section>
    </main>
  );
}
